<template lang="">
  <div class="bbs_write">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">카테고리</th>
          <td>
            <div class="item">
              <select name="" id="" class="i_sel" style="width:260px" v-model="categorySeq">
                <option
                  v-for="category in categoryListForCreate"
                  :value="category.categorySeq"
                >{{ category.name }}</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">단체명</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="단체명을 입력하세요." v-model="groupName">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">단체 설명</th>
          <td>
            <div class="item">
              <textarea name="" id="" cols="30" class="i_ta type_full lineless" placeholder="단체 설명을을 입력하세요." v-model="groupExplain"></textarea>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"></th>
          <td class="editor">
            <quill-editor
              v-model:value="editorHtml"
              :options="editorOption"
            ></quill-editor>
          </td>
        </tr>
        <tr>
          <th scope="row">썸네일 이미지</th>
          <td>
            <div class="item item_attach">
              <p class="note">(확장자는 jpg, pdf, doc, ppt, hwp, zip 만 가능합니다.)</p>
              <div class="ui_attach">
                <input type="text" class="i_txt i_file" :value="thumbnail.fileName" @click="triggerFileInput()" readonly>
                <button type="button" class="bt_base primary btn_attach" @click="triggerFileInput()"> 찾아보기</button>
                <button type="button" class="bt_base gray type_ico" v-if="thumbnail.previewUrl" @click="removeFile()" style="margin-right:5px"> &minus; </button>
                <input type="file" name="file" class="i_upload" style="display: none" @change="handleFileChange()" ref="file" accept="image/*">
                <div v-if="thumbnail.previewUrl" class="preview">
                  <img :src="$getImgUrl(thumbnail.previewUrl)" alt="이미지 미리보기" style="max-width: 200px; max-height: 200px; margin-top: 10px;">
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="bbs_controller">
    <div class="lft_area">
      <a class="bt_base gray large_h btn_list" @click="toList">목록</a>
    </div>

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createDonationGroup">저장</button>
      <button type="reset" class="bt_base gray large_h" v-if="donationGroupSeq" @click="deleteDonationGroup">삭제</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

const adminDonationGroupModule = "adminDonationGroupModule"
const adminCategoryModule = "adminCategoryModule"

export default {
  data (){
    return {
      donationGroupSeq: this.$route.query.donationGroupSeq,
      categorySeq: '',
      groupName: '',
      groupExplain: '',
      editorHtml: '',
      deletedFileSeq: null,
      thumbnail: {
        file: null,
        fileName: '',
        previewUrl: null,
        fileSeq: null
      },
      editorOption: {},
    }
  },
  methods: {
    ...mapActions(adminDonationGroupModule, [
        'requestSaveDonationGroup',
        'requestDonationGroup',
        'requestDeleteDonationGroups',
        'requestEditorImageUpload'
      ]),

    ...mapActions(adminCategoryModule, [
      'requestCategoryListForCreate'
    ]),

    triggerFileInput() {
      this.$refs.file.click();
    },

    toList () {
      this.$router.push({ name: "DonationGroupManageListPage" })
    },

    async createDonationGroup() {
      const { donationGroupSeq, categorySeq, groupName, groupExplain, editorHtml, deletedFileSeq, thumbnail } = this

      const formData = new FormData();

      formData.append('donationGroupSeq', donationGroupSeq ? donationGroupSeq : -1);
      formData.append('categorySeq', categorySeq);
      formData.append('groupName', groupName);
      formData.append('groupExplain', groupExplain);
      formData.append('editorHtml', editorHtml);
      formData.append('deletedFileSeqs', [deletedFileSeq]);
      formData.append('thumbnail', thumbnail.file);

      const result = await this.requestSaveDonationGroup(formData)
      if (result) {
        alert(result)
        this.$router.push({ name: "DonationGroupManageListPage" })
      }
    },

    handleFileChange () {
      const fileInput = this.$refs.file;
      const file = fileInput.files[0];
      if (file) {
        if (!file.type.startsWith("image/")) {
          alert("이미지 파일만 업로드할 수 있습니다.");
          fileInput.value = "";
          this.thumbnail.file = null;
          this.thumbnail.fileName = "";
          this.thumbnail.previewUrl = null;
          return;
        }

        this.thumbnail.file = file;
        this.thumbnail.fileName = file.name;
        if(this.thumbnail.fileSeq) this.deletedFileSeq = this.thumbnail.fileSeq;

        const reader = new FileReader();
        reader.onload = (e) => {
          this.thumbnail.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    removeFile () {
      this.$refs.file.value = "";
      this.thumbnail.file = null;
      this.thumbnail.fileName = "";
      this.thumbnail.previewUrl = null;
      if(this.thumbnail.fileSeq){
        this.deletedFileSeq = this.thumbnail.fileSeq;
      }
    },

    async deleteDonationGroup () {
      const donationGroupSeq = this.donationGroupSeq;
      const result = await this.requestDeleteDonationGroups([ donationGroupSeq ]);
      if (result) {
        alert("삭제되었습니다.")
        this.$router.push({ name: "DonationGroupManageListPage" })
      }
    }
  },

  computed: {
    ...mapState(adminDonationGroupModule, ['donationGroup']),

    ...mapState(adminCategoryModule, [
      'categoryListForCreate'
    ])
  },

  async mounted() {
    await this.requestCategoryListForCreate('기부후원단체');

    if (this.donationGroupSeq) {
      await this.requestDonationGroup(this.donationGroupSeq);
      this.categorySeq = this.donationGroup.category.categorySeq;
      this.groupName = this.donationGroup.groupName;
      this.groupExplain = this.donationGroup.groupExplain;
      this.editorHtml = this.donationGroup.editorHtml;

      if (this.donationGroup.attachList.length != 0){
        const index = this.donationGroup.attachList.length;
        this.thumbnail.previewUrl = this.donationGroup.attachList[index - 1].path;
        this.thumbnail.fileName = this.donationGroup.attachList[index - 1].originalName;
        this.thumbnail.fileSeq = this.donationGroup.attachList[index - 1].donationGroupAttachSeq;
      }
    } else {
      this.categorySeq = this.categoryListForCreate[0].categorySeq
    }
  },

  created () {
    const self = this
    this.editorOption = Object.assign({}, this.editorOption, {
      placeholder: '내용을 입력해주세요...',
        modules: {
          toolbar: {
            container: [
              ['bold', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['link', 'image', 'video']
            ],
            handlers: {
              image: function () {
                const input = document.createElement('input')
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');
                input.click();
    
                input.onchange = async () => {
                  
                  const file = input.files[0];
                  if (file) {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('uploadBoard', 'donationGroup');
                    const result = await self.requestEditorImageUpload(formData);
    
                    if (result) {
                      const range = this.quill.getSelection();
                      this.quill.insertEmbed(range.index, 'image', self.$getImgUrl(result));
                    } else {
                      alert('이미지 업로드 실패');
                    }
                  }
                };
              }
            }
          }
        }
    })
  }

}
</script>
<style lang="">
    
</style>